import React from 'react';
import { cn } from '../utils/cn';

function SelectInput({ label, hint, error, options = [], placeholder, ...rest }) {
  return (
    <div className="field">
      {label && <label>{label}</label>}
      <select className={cn('select', error && 'is-error')} {...rest}>
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((o) => {
          const value = typeof o === 'object' ? o.value : o;
          const text  = typeof o === 'object' ? o.label : o;
          return <option key={value} value={value}>{text}</option>;
        })}
      </select>
      {error ? <div className="err">{error}</div> : hint ? <div className="hint">{hint}</div> : null}
    </div>
  );
}

export default SelectInput;
